import React from 'react';
import ConnectHomeShell, { getConnectHomeCopy } from './ConnectHomeShell';

export default function LoadingBlock({ message }) {
    if (message) {
        return <div className="connect-startup-message">{message}</div>;
    }

    const languageCode = typeof window !== 'undefined'
        ? window.Telegram?.WebApp?.initDataUnsafe?.user?.language_code
        : 'en';

    return (
        <ConnectHomeShell
            languageCode={languageCode}
            labels={getConnectHomeCopy(languageCode)}
            ready={false}
        />
    );
}
